import * as React from 'react'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { WithTitle } from '../../common/props/layoutProps';

const styles = (theme: Theme) => ({
    title: {
        marginTop: theme.spacing(2)
    }
});

type ContainerProps = WithTitle & WithStyles<"title">;

const StatisticsContainer: React.SFC<ContainerProps> = (props) => {
    const { classes, title } = props;

    return <Grid item>
        <Grid container direction="column" spacing={4}>
            <Grid item>
                <Typography className={classes.title} color="primary" variant="h4">{title}</Typography>
            </Grid>
            <Grid item>
                <Grid container spacing={4}>
                    {props.children}
                </Grid>
            </Grid>
        </Grid>
    </Grid>
}

export default withStyles(styles)(StatisticsContainer);


// WEBPACK FOOTER //
// ./src/statistics/components/StatisticsContainer.tsx